import { ShieldCheck, Award, MapPin, Star } from "lucide-react";

type Item = {
  icon: typeof ShieldCheck;
  value: string;
  label: string;
};

const ITEMS: Item[] = [
  { icon: Award, value: "Certified", label: "Panasonic Installer" },
  { icon: ShieldCheck, value: "20+ Years", label: "Hands-on experience" },
  { icon: MapPin, value: "Mangawhai", label: "Local · Northland" },
  { icon: Star, value: "5.0 ★", label: "Google Reviews" },
];

export default function TrustStrip() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-brand-800 via-brand-600 to-brand-800 py-10 md:py-12">
      {/* Soft radial highlight */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.18),transparent_60%)]"
      />
      {/* Hairline top + bottom */}
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-white/10" />
      <div aria-hidden className="absolute inset-x-0 bottom-0 h-px bg-black/10" />

      <div className="container relative">
        <ul className="grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0 md:divide-x md:divide-white/15">
          {ITEMS.map(({ icon: Icon, value, label }) => (
            <li
              key={label}
              className="flex flex-col items-center justify-center gap-2 text-center md:px-4"
            >
              <div className="mb-1 inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/25 backdrop-blur-sm">
                <Icon className="h-5 w-5 text-white" strokeWidth={2.25} />
              </div>
              <div className="font-sans text-2xl font-bold leading-none tracking-tight text-white md:text-[1.6rem]">
                {value}
              </div>
              <div className="text-xs font-medium uppercase tracking-[0.12em] text-white/80">
                {label}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
